var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/Filter.ts";
import * as t from 'io-ts';
import { Id } from '../Id';
export var Filter;

(function (_Filter) {
  var ConditionTypeIO = _Filter.ConditionTypeIO = t.union([t.literal('UserClassifier'), t.literal('AssemblyClassifier'), t.literal('AnonymousClassifier'), t.literal('UserClassifierGroupWithElements'), t.literal('UserClassifierGroupWithGroups'), t.literal('UserClassifierEmptyGroup'), t.literal('BimStandardSize'), t.literal('BimModel'), t.literal('BimCategory'), t.literal('BimFamily')]);
  var FilterCondition;

  (function (FilterCondition) {
    FilterCondition["Equals"] = "Equals";
    FilterCondition["NotEquals"] = "NotEquals";
    FilterCondition["GreaterThan"] = "GreaterThan";
    FilterCondition["GreaterThanOrEqualsTo"] = "GreaterThanOrEqualsTo";
    FilterCondition["LessThan"] = "LessThan";
    FilterCondition["LessThanOrEqualsTo"] = "LessThanOrEqualsTo";
    FilterCondition["Contain"] = "Contain";
    FilterCondition["NotContain"] = "NotContain";
  })(FilterCondition || (FilterCondition = {}));

  _Filter.FilterCondition = FilterCondition;
  var ConditionProperty = _Filter.ConditionProperty = t.type({
    propertyGroupName: t.string,
    propertyName: t.string,
    value: t.string,
    filterCondition: t.union([t.literal(FilterCondition.Equals), t.literal(FilterCondition.NotEquals), t.literal(FilterCondition.GreaterThan), t.literal(FilterCondition.GreaterThanOrEqualsTo), t.literal(FilterCondition.LessThan), t.literal(FilterCondition.LessThanOrEqualsTo), t.literal(FilterCondition.Contain), t.literal(FilterCondition.NotContain)])
  });
  var Source = _Filter.Source = t.type({
    type: ConditionTypeIO,
    id: Id
  });
  var Condition = _Filter.Condition = t.type({
    properties: t.array(ConditionProperty),
    sources: t.array(Source)
  });
  var Data = _Filter.Data = Condition;
})(Filter || (Filter = {}));